// Rounded buttons and round arrows open a cut stone of Ence under the pointer (assets/base.css),
// ported from dornor-prototype site/shared.js. Each gets a white copy of its words (data-label) or its
// arrow (.arrow-on) for inside the stone, before any hover. When the pointer comes in, --reach is set
// to the stone's size that just covers the button from its middle: its top must clear the top edge,
// its slanted sides the corners.
(() => {
  const BUTTONS = ".pill, .slider__button, .buy-bar__heart";
  const dress = (b) => {
    if (b.matches(".pill") && !b.dataset.label) b.dataset.label = b.textContent.trim();
    const arrow = b.matches(".slider__button, .buy-bar__heart") && !b.querySelector(".arrow-on") && b.querySelector("svg");
    if (arrow) {
      const on = document.createElement("span");
      on.className = "arrow-on";
      on.setAttribute("aria-hidden", "true");
      on.append(arrow.cloneNode(true));
      b.append(on);
    }
  };
  const dressAll = () => document.querySelectorAll(BUTTONS).forEach(dress);
  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", dressAll);
  else dressAll();
  document.addEventListener("shopify:section:load", dressAll);
  document.addEventListener("pointerover", (e) => {
    const b = e.target.closest?.(BUTTONS);
    if (!b || b.contains(e.relatedTarget)) return;
    dress(b);
    const w = b.offsetWidth, h = b.offsetHeight;
    b.style.setProperty("--reach", `${Math.max(h / 0.9, (w + h) / 2) + 2}px`);
  });
})();
